import { type SupabaseClient } from '@supabase/supabase-js';
import { createBrowserClient as createSSRBrowserClient } from '@supabase/ssr';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
let browserClient: SupabaseClient | null = null;

function getSupabaseCredentials() {
  if (!supabaseUrl) {
    console.error('Missing NEXT_PUBLIC_SUPABASE_URL environment variable');
    throw new Error('Missing Supabase URL. Please check your environment variables.');
  }

  if (!supabaseAnonKey) {
    console.error('Missing NEXT_PUBLIC_SUPABASE_ANON_KEY environment variable');
    throw new Error('Missing Supabase Anon Key. Please check your environment variables.');
  }

  return { supabaseUrl, supabaseAnonKey };
}

function getBrowserClient() {
  if (browserClient) {
    return browserClient;
  }

  const { supabaseUrl: url, supabaseAnonKey: key } = getSupabaseCredentials();

  // Usar createBrowserClient de @supabase/ssr para que la sesión se guarde
  // en cookies (en vez de localStorage), permitiendo que los server components
  // lean la sesión correctamente.
  browserClient = createSSRBrowserClient(url, key);

  return browserClient;
}

// Lazily resolve the browser client so static prerendering does not fail at import time.
export const supabase = new Proxy({} as SupabaseClient, {
  get(_target, prop, receiver) {
    const client = getBrowserClient();
    return Reflect.get(client, prop, receiver);
  },
});

export function createClient() {
  return getBrowserClient();
}

// Create browser-specific Supabase client
export function createBrowserClient() {
  return getBrowserClient();
}
function signIn(...args: any[]): any {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: signIn is not implemented yet.', args);
  return null;
}

export { signIn };
function signUp(...args: any[]): any {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: signUp is not implemented yet.', args);
  return null;
}

export { signUp };
